export default [
  {
    label: 'Full-Time',
    value: 'full_time',
  },
  {
    label: 'Part-Time',
    value: 'part_time',
  },
];
